import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Button } from 'reactstrap';
import { getAllPrograms } from '@/shared/apiHelper.jsx';
import { labelizeNamedData } from '@/shared/helpers';
import { STATE_FILTER_OPTIONS } from './queueState';

const ALL_PROGRAMS = { label: 'All Programs', value: '' };
const DEFAULT_STATE = STATE_FILTER_OPTIONS.find((o) => o.value === 'pending');

const FundingApprovalsFilter = ({ onClickFilterCallback, setUseFilter }) => {
  const [keyword, setKeyword] = useState('');
  const [state, setState] = useState(DEFAULT_STATE);
  const [programOptions, setProgramOptions] = useState([ALL_PROGRAMS]);
  const [program, setProgram] = useState(ALL_PROGRAMS);
  const [heldFrom, setHeldFrom] = useState('');
  const [heldTo, setHeldTo] = useState('');
  const [dateError, setDateError] = useState(null);

  useEffect(() => {
    let active = true;
    getAllPrograms('minimal=true&limit=99999999')
      .then((result) => {
        if (active) setProgramOptions([ALL_PROGRAMS, ...labelizeNamedData(result?.data ?? [])]);
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  const apply = (values) => {
    onClickFilterCallback(values);
    setUseFilter(true);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    if (heldFrom && heldTo && heldTo < heldFrom) {
      setDateError('"Held to" cannot be earlier than "Held from".');
      return;
    }
    setDateError(null);
    apply({
      state: state?.value ?? 'pending',
      keyword,
      program_id: program?.value ?? '',
      held_from: heldFrom,
      held_to: heldTo,
    });
  };

  const onReset = (event) => {
    event.preventDefault();
    setKeyword('');
    setState(DEFAULT_STATE);
    setProgram(ALL_PROGRAMS);
    setHeldFrom('');
    setHeldTo('');
    setDateError(null);
    apply({ state: 'pending', keyword: '', program_id: '', held_from: '', held_to: '' });
  };

  return (
    <div className="form form--horizontal">
    <form className="form__form-group flex-wrap align-items-start w-100" onSubmit={onSubmit}>
      <div className="col-12 col-md-6 col-xl-2 pr-0 mb-2">
        <p>Keyword</p>
        <input
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          type="text"
          maxLength={100}
          aria-label="Keyword"
          placeholder="Search by program or invoice #"
        />
      </div>
      <div className="col-12 col-md-6 col-xl-2 pr-0 mb-2">
        <p>Status</p>
        <Select
          value={state}
          onChange={setState}
          options={STATE_FILTER_OPTIONS}
          clearable={false}
          className="react-select"
          classNamePrefix="react-select"
        />
      </div>
      <div className="col-12 col-md-6 col-xl-2 pr-0 mb-2">
        <p>Program</p>
        <Select
          value={program}
          onChange={setProgram}
          options={programOptions}
          clearable={false}
          className="react-select"
          classNamePrefix="react-select"
          placeholder="All Programs"
        />
      </div>
      <div className="col-12 col-md-6 col-xl-2 pr-0 mb-2">
        <p>Held from</p>
        <input type="date" aria-label="Held from" value={heldFrom} onChange={(e) => setHeldFrom(e.target.value)} />
      </div>
      <div className="col-12 col-md-6 col-xl-2 pr-0 mb-2">
        <p>Held to</p>
        <input type="date" aria-label="Held to" min={heldFrom || undefined} value={heldTo} onChange={(e) => setHeldTo(e.target.value)} />
        {dateError && <div role="alert" className="text-danger">{dateError}</div>}
      </div>
      <div className="col-auto pr-0 mb-2 d-flex align-items-end flex-nowrap flex-shrink-0" style={{ alignSelf: 'flex-end' }}>
        <Button type="submit" className="btn btn-sm btn-primary mb-0 text-nowrap" color="#ffffff">Filter</Button>
        <Button type="button" className="btn btn-sm btn-secondary mb-0 ml-2 text-nowrap" onClick={onReset}>Reset</Button>
      </div>
    </form>
    </div>
  );
};

export default FundingApprovalsFilter;
